import React from 'react'

import {
  Layout,
  Header,
  Section,
  Grid,
  GridItem,
  Intro,
  SectionTitle,
  Paragraph,
} from '../../../../components'

import './style.scss'
import data from './data.json'

import assetsEditor from '../../../../images/PanelandToolbar.png'
import EnableMT from '../../../../images/Enable-MT.png'
import UpToast from '../../../../images/Update-Toast.png'
import LibIcon from '../../../../images/Library-Icon.png'
import PlaceMT from '../../../../images/Place-Asset-MT.png'
import SetVarMT from '../../../../images/Set-Variant-MT.png'
import SetStyleMT from '../../../../images/Set-Style-MT.png'

import figma from '../../../../images/figma.svg'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        subtitle={data.subtitle}
        slug={data.slug + '/design/'}
        site={data.site}
        state="design"
        title="Start Designing"
        complete={true}
      >
        <Intro noBorder={true}>
          <p>
            Currency components are a collection of interface elements that can
            be reused across M&T Bank and Wilmington Trust's digital products.
            Components can be combined to create user interfaces consistent with
            the bank’s principles, design language and best practices.
          </p>
          <p>
            If you are new to Currency, explore the <strong>Guidelines</strong>{' '}
            to learn the M&T product design principles. To familiarize yourself
            with the existing assets which you can incorporate into your
            designs, review the <strong>Components</strong> and{' '}
            <strong>Patterns</strong> sections.
          </p>
        </Intro>

        <Section type="gray" className="floating l-margin-bottom--xxlarge">
          <Grid>
            <GridItem columns="12">
              <img
                alt="figma logo"
                src={figma}
                width="100px"
                className="figma-logo"
              />
              <div className="new-subtitle">Software</div>
              <h3 className="getting-started-h3">Figma</h3>
              <Paragraph size="large">
                Currency uses{' '}
                <a className="link" href="//figma.com">
                  Figma
                </a>{' '}
                to manage design tokens and assets. This is the same platform
                that designers will use to create and share designs and
                prototypes.
              </Paragraph>
              <Paragraph size="large">
                Figma can be accessed via the web app or the desktop app and
                needs an active internet connection to connect to the Currency
                Design System.
              </Paragraph>
            </GridItem>
          </Grid>
        </Section>
        <Section className="l-padding-vertical--xxlarge">
          <Grid>
            <GridItem columns="6">
              <SectionTitle className="getting-started-h3">
                Using the Currency Figma Library
              </SectionTitle>
              <Paragraph size="medium">
                The M&T Currency Design System library is available to all
                members of the M&T Figma organization. You can enable which
                libraries automatically show up in your draft files in your user
                settings.
              </Paragraph>
            </GridItem>
            <GridItem columns="6">
              <img
                alt="Enable libraries in drafts"
                src={EnableMT}
                width="85%"
              />
            </GridItem>
          </Grid>
          <Grid>
            <GridItem columns="6">
              <img alt="Editor Toolbar Library Modal" src={assetsEditor} />
            </GridItem>
            <GridItem columns="6">
              <SectionTitle className="l-padding-left--xxlarge l-padding-top--xxlarge getting-started-h3">
                Accessing the library within a file
              </SectionTitle>
            </GridItem>
          </Grid>
        </Section>
        <Section type="gray" className="floating l-margin-bottom--xxlarge">
          <SectionTitle className="getting-started-h3">
            Syncing Your Library
          </SectionTitle>
          <Grid>
            <GridItem columns="6">
              <Paragraph size="medium">
                In Figma, you can immediately sync Currency library changes
                straight to your working files. When new components or styles
                are added, or when existing components and styles{' '}
                <strong>within your file</strong> are changed, a notification
                will appear in the bottom-right corner of your screen.
              </Paragraph>

              <Paragraph>
                You can review the changes made to the components and accept
                them, or dismiss the notification. It will appear every time you
                open an affected file.
              </Paragraph>
              <Paragraph>
                You can also update the Currency library from the libraries
                modal. There will be a blue notification dot on the libraries
                icon{' '}
                <img
                  alt="Library Icon"
                  src={LibIcon}
                  className="u-display--inline"
                />{' '}
                to alert you of updates. Assets you choose not to update will
                still be connected to the main Currency instance. You can choose
                to update at any time.
              </Paragraph>
            </GridItem>
            <GridItem
              columns="6"
              className="u-flex-container u-flex-align--middle"
            >
              <img alt="Update Toast" src={UpToast} width="75%" />{' '}
            </GridItem>
          </Grid>
        </Section>
        <Section className="l-padding-vertical--xxlarge">
          <Grid>
            <GridItem columns="6">
              <SectionTitle className="getting-started-h3">
                <span className="unbold">Placing</span> Assets
              </SectionTitle>
            </GridItem>
            <GridItem columns="6">
              <img
                alt="Placing an asset"
                src={PlaceMT}
                className="l-margin-left--xlarge"
              />
            </GridItem>
            <div className="floating-row">
              <Grid>
                <GridItem columns="4" className="u-flex-container">
                  <div className="floating-row__item">
                    <div className="new-subtitle">One</div>
                    <Paragraph size="small">
                      Select the asset you want to apply styles to from the
                      canvas or from the Layers tab of the left panel.
                    </Paragraph>
                  </div>
                </GridItem>
                <GridItem columns="4" className="u-flex-container">
                  <div className="floating-row__item">
                    <div className="new-subtitle">Two</div>
                    <Paragraph size="small">
                      In the Design tab of the right panel, click the four dots
                      on the right side of the appropriate section to access the
                      Currency library styles. For shadows, simply click the
                      plus icon.
                    </Paragraph>
                  </div>
                </GridItem>
                <GridItem columns="4" className="u-flex-container">
                  <div className="floating-row__item">
                    <div className="new-subtitle">Three</div>
                    <Paragraph size="small">
                      Select the style you want to apply to the element.
                    </Paragraph>
                  </div>
                </GridItem>
              </Grid>
            </div>
          </Grid>
        </Section>
        <Section className="l-padding-vertical--xxlarge">
          <Grid>
            <GridItem columns="6">
              <SectionTitle className="getting-started-h3">
                <span className="unbold">Setting</span> Variants and States
              </SectionTitle>
              <Grid>
                <GridItem columns="12">
                  <Paragraph>
                    To change the variant, state, size or any other variable
                    properties of the base asset select the asset and edit the
                    properties in the Design tab of the right panel.
                  </Paragraph>
                </GridItem>
              </Grid>
            </GridItem>
            <GridItem columns="6">
              <img
                alt="Setting asset variants"
                src={SetVarMT}
                className="l-margin-left--xlarge"
              />
            </GridItem>
          </Grid>
        </Section>
        <Section className="l-padding-vertical--xxlarge">
          <Grid>
            <GridItem columns="6">
              <SectionTitle className="getting-started-h3">
                <span className="unbold">Placing</span> Text, Grids, Colors and
                Styles
              </SectionTitle>
              <Paragraph>
                In Figma, foundational elements like text, grids, fills and
                shadows are called Styles. Unlike DSM, styles are not discreet
                assets that you can drag into your file. Instead, they are
                properties that can be applied to any assets you create. All
                styles are adjusted in the Design tab of the right panel.
              </Paragraph>
            </GridItem>
            <GridItem columns="6">
              <img
                alt="Setting Styles"
                src={SetStyleMT}
                className="l-margin-left--xlarge"
              />
            </GridItem>
            <div className="floating-row">
              <Grid>
                <GridItem columns="4" className="u-flex-container">
                  <div className="floating-row__item">
                    <div className="new-subtitle">One</div>
                    <Paragraph size="small">
                      Select the asset you want to apply styles to from the
                      canvas or from the Layers tab of the left panel.
                    </Paragraph>
                  </div>
                </GridItem>
                <GridItem columns="4" className="u-flex-container">
                  <div className="floating-row__item">
                    <div className="new-subtitle">Two</div>
                    <Paragraph size="small">
                      In the Design tab of the right panel, click the four dots
                      on the right side of the appropriate section to access the
                      Currency library styles. For shadows, simply click the
                      plus icon.
                    </Paragraph>
                  </div>
                </GridItem>
                <GridItem columns="4" className="u-flex-container">
                  <div className="floating-row__item">
                    <div className="new-subtitle">Three</div>
                    <Paragraph size="small">
                      Select the style you want to apply to the element.
                    </Paragraph>
                  </div>
                </GridItem>
              </Grid>
            </div>
          </Grid>
        </Section>
      </Layout>
    </>
  )
}
